import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { CalendarCheck, ClipboardList, BookOpen } from 'lucide-react';

const HowItWorksSection = () => {
  const { language } = useLanguage();
  const sv = language === 'sv';

  const steps = sv ? [
    { icon: CalendarCheck, num: '1', title: 'Boka gratis provlektion', desc: 'Vi testar elevens nivå i Koranläsning.' },
    { icon: ClipboardList, num: '2', title: 'Personlig studieplan', desc: 'Eleven placeras i rätt grupp baserat på nivå.' },
    { icon: BookOpen, num: '3', title: 'Starta lektioner', desc: 'Små grupper med personlig uppmärksamhet och tydlig tajweed.' },
  ] : [
    { icon: CalendarCheck, num: '1', title: 'Book free trial lesson', desc: 'We test the student\'s Quran reading level.' },
    { icon: ClipboardList, num: '2', title: 'Personal study plan', desc: 'The student is placed in the right group based on level.' },
    { icon: BookOpen, num: '3', title: 'Start lessons', desc: 'Small groups with personal attention and clear tajweed.' },
  ];

  return (
    <section className="py-24" style={{ backgroundColor: 'var(--bg-secondary)' }} data-testid="how-it-works-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: 'var(--text-primary)' }}>
            {sv ? 'Hur lektionerna fungerar' : 'How the Lessons Work'}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="text-center" data-testid={`step-${i}`}>
                <div className="w-16 h-16 rounded-full mx-auto mb-5 flex items-center justify-center bg-gold/10 border border-gold/20 relative">
                  <Icon size={26} className="text-gold" />
                  <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-gold text-black text-xs font-bold flex items-center justify-center">{s.num}</span>
                </div>
                <h3 className="font-semibold mb-2 text-base" style={{ color: 'var(--text-primary)' }}>{s.title}</h3>
                <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
